import {
  Heading,
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  List,
  ListItem
} from "@chakra-ui/react";

interface SourcesListProps {
  sources: string[];
  organizationalUnit: string[];
}

/**
 * A React component that renders a list of sources and organizational units
 * within an accordion. The accordion allows multiple sections to be expanded
 * at the same time.
 *
 * @param {SourcesListProps} props - The properties for the SourcesList component.
 * @param {string[]} props.sources - An array of sources to be displayed.
 * @param {string[]} props.organizationalUnit - An array of organizational units to be displayed.
 *
 * @returns {JSX.Element} The rendered SourcesList component.
 */
export default function SourcesList({ sources, organizationalUnit }: SourcesListProps) {

  return (
    <>
      <Accordion allowMultiple backgroundColor={"white"}>
        <AccordionItem>
          <AccordionButton>
            <Box flex='1' textAlign='left'>
              <Heading size="xs" as="h5" textTransform="uppercase" alignItems={"center"}>
                Unità organizzativa di riferimento e fonti documentali dell'indicatore
              </Heading>
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={5} fontSize={"small"}>
            <span style={{ fontWeight: "bold" }}>
              Unità organizzativa di riferimento:
            </span>
            <List variant="marker" mb={3}>
              {organizationalUnit.map((unit, index) => (
                <ListItem key={index}><span aria-hidden="true">-</span> {unit}</ListItem>
              ))
              }
            </List>
            <span style={{ fontWeight: "bold" }}>
              Fonti documentali:
            </span>
            <List>
              {sources.map((source, index) => (
                <ListItem key={index}><span aria-hidden="true">-</span> {source}</ListItem>
              ))
              }
            </List>
          </AccordionPanel>
        </AccordionItem>
      </Accordion >
    </>

  );
}
